// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"804":"5a56ea10","2008":"cc30da7e","4934":"cc30da7e","5061":"cc30da7e"}[chunkId] + ".chunk.css";
};